import { render, staticRenderFns } from "./BrandPwdCheck.vue?vue&type=template&id=62975bcd&"
import script from "./BrandPwdCheck.vue?vue&type=script&lang=js&"
export * from "./BrandPwdCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports